import { h } from 'preact';

const Icon = ({ id }) => {
    const html = `<use xlink:href="#${id}"></use>`;
    return <svg class="icon" dangerouslySetInnerHTML={{__html: html}}></svg>;
};

export default Icon;


// WEBPACK FOOTER //
// ./src/components/Icon.js